import { __decorate } from "tslib";
import { AnyDecoder, ArrayDecoder, AutoEncoder, DateDecoder, EnumDecoder, field, IntegerDecoder, StringDecoder } from '@simonbackx/simple-encoding';
import { v4 as uuidv4 } from 'uuid';
import { BalanceItem, BalanceItemWithPayments } from './BalanceItem.js';
import { PaymentGeneral } from './members/PaymentGeneral.js';
import { upgradePriceFrom2To4DecimalPlaces } from './upgradePriceFrom2To4DecimalPlaces.js';
import { PaymentCustomer } from './PaymentCustomer.js';
export var ReceivableBalanceType;
(function (ReceivableBalanceType) {
    ReceivableBalanceType["organization"] = "organization";
    ReceivableBalanceType["member"] = "member";
    ReceivableBalanceType["user"] = "user";
    ReceivableBalanceType["registration"] = "registration";
    ReceivableBalanceType["userWithoutMembers"] = "userWithoutMembers";
})(ReceivableBalanceType || (ReceivableBalanceType = {}));
export function getReceivableBalanceTypeName(type) {
    switch (type) {
        case ReceivableBalanceType.organization: return $t('%78');
        case ReceivableBalanceType.member: return $t('%79');
        case ReceivableBalanceType.user: return $t('%2S');
        case ReceivableBalanceType.registration: return $t('%82');
        case ReceivableBalanceType.userWithoutMembers: return $t('%2S');
    }
}
export class ReceivableBalanceObjectContact extends AutoEncoder {
    firstName = null;
    lastName = null;
    emails = [];
    /**
     * Meta data that is used for filtering who to email
     */
    meta = null;
}
__decorate([
    field({ decoder: StringDecoder, nullable: true })
], ReceivableBalanceObjectContact.prototype, "firstName", void 0);
__decorate([
    field({ decoder: StringDecoder, nullable: true })
], ReceivableBalanceObjectContact.prototype, "lastName", void 0);
__decorate([
    field({ decoder: new ArrayDecoder(StringDecoder) })
], ReceivableBalanceObjectContact.prototype, "emails", void 0);
__decorate([
    field({ decoder: AnyDecoder, nullable: true, version: 346 })
], ReceivableBalanceObjectContact.prototype, "meta", void 0);
export class ReceivableBalanceObject extends AutoEncoder {
    id;
    name = '';
    /**
     * Only used for organization type
     */
    uri = null;
    // E-mail addresses to reach out to this entity
    contacts = [];
    /**
     * Customer to use when creating new payments
     */
    customers = [];
}
__decorate([
    field({ decoder: StringDecoder, defaultValue: () => uuidv4() })
], ReceivableBalanceObject.prototype, "id", void 0);
__decorate([
    field({ decoder: StringDecoder })
], ReceivableBalanceObject.prototype, "name", void 0);
__decorate([
    field({ decoder: StringDecoder, nullable: true, version: 362 })
], ReceivableBalanceObject.prototype, "uri", void 0);
__decorate([
    field({ decoder: new ArrayDecoder(ReceivableBalanceObjectContact) })
], ReceivableBalanceObject.prototype, "contacts", void 0);
__decorate([
    field({ decoder: new ArrayDecoder(PaymentCustomer), version: 393 })
], ReceivableBalanceObject.prototype, "customers", void 0);
/**
 * An entity (organization, member or user) that has an outstanding balance towards an organization
 */
export class ReceivableBalance extends AutoEncoder {
    id;
    objectType;
    object;
    /**
     * The organization that should receive the outstanding balance
     */
    organizationId;
    amountPaid = 0;
    amountOpen = 0;
    amountPending = 0;
    lastReminderEmail = null;
    lastReminderAmountOpen = 0;
    reminderEmailCount = 0;
}
__decorate([
    field({ decoder: StringDecoder, defaultValue: () => uuidv4() })
], ReceivableBalance.prototype, "id", void 0);
__decorate([
    field({ decoder: new EnumDecoder(ReceivableBalanceType) })
], ReceivableBalance.prototype, "objectType", void 0);
__decorate([
    field({ decoder: ReceivableBalanceObject })
], ReceivableBalance.prototype, "object", void 0);
__decorate([
    field({ decoder: StringDecoder })
], ReceivableBalance.prototype, "organizationId", void 0);
__decorate([
    field({ decoder: IntegerDecoder, version: 354 }),
    field({ ...upgradePriceFrom2To4DecimalPlaces })
], ReceivableBalance.prototype, "amountPaid", void 0);
__decorate([
    field({ decoder: IntegerDecoder, field: 'amount' }),
    field({ decoder: IntegerDecoder, version: 354 }),
    field({ ...upgradePriceFrom2To4DecimalPlaces })
], ReceivableBalance.prototype, "amountOpen", void 0);
__decorate([
    field({ decoder: IntegerDecoder }),
    field({ ...upgradePriceFrom2To4DecimalPlaces })
], ReceivableBalance.prototype, "amountPending", void 0);
__decorate([
    field({ decoder: DateDecoder, nullable: true, version: 355 })
], ReceivableBalance.prototype, "lastReminderEmail", void 0);
__decorate([
    field({ decoder: IntegerDecoder, version: 355 }),
    field({ ...upgradePriceFrom2To4DecimalPlaces })
], ReceivableBalance.prototype, "lastReminderAmountOpen", void 0);
__decorate([
    field({ decoder: IntegerDecoder, version: 355 })
], ReceivableBalance.prototype, "reminderEmailCount", void 0);
export class DetailedReceivableBalance extends ReceivableBalance {
    balanceItems = [];
    payments = [];
    get filteredBalanceItems() {
        return BalanceItem.filterBalanceItems(this.balanceItems);
    }
    get payableBalanceItems() {
        return BalanceItem.filterPayableBalanceItems(this.balanceItems);
    }
    get discountBalanceItems() {
        return BalanceItem.filterDiscountBalanceItems(this.balanceItems);
    }
}
__decorate([
    field({ decoder: new ArrayDecoder(BalanceItemWithPayments) })
], DetailedReceivableBalance.prototype, "balanceItems", void 0);
__decorate([
    field({ decoder: new ArrayDecoder(PaymentGeneral) })
], DetailedReceivableBalance.prototype, "payments", void 0);
//# sourceMappingURL=ReceivableBalance.js.map